module.exports = __webpack_public_path__ + "img/Financial-logo.c969b60c.svg";